'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface StageItem {
	number: string
	title: string
	description: string
}

const ThreeModels: React.FC = () => {
	const stages: StageItem[] = [
		{
			number: '01',
			title: 'Отдельный специалист',
			description: 'Вы берёте конкретного специалиста из нашего резерва и включаете его в свою команду. Ставите задачи напрямую, общаетесь без посредников, управляете сами. Специалист может подключиться на любом этапе.<br><br><span>Подходит, когда:</span> в команде не хватает одной роли, нужно закрыть конкретный стек или временно усилить нагрузку.'
		},
		{
			number: '02',
			title: 'Команда под вашим управлением',
			description:
				'Мы формируем команду специалистов — вы управляете ею самостоятельно: распределяете задачи и сроки, контролируете процесс. Не тратите время на поиск и найм, но сохраняете полный контроль над проектом.<br><br><span>Подходит, когда:</span> нужна готовая команда на проект, но вы хотите управлять разработкой сами'
		},
		{
			number: '03',
			title: 'Команда под управлением true.code',
			description: 'Мы собираем команду под ваш проект и берём на себя управление: планирование, координацию, контроль.  Вы получаете результат и отчётность, не погружаясь в операционку.<br><br><span>Подходит, когда:</span> хотите полностью делегировать разработку и сосредоточиться на бизнесе.'
		}
	]

	return (
		<section className={styles.threeModels}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation='slideUp'>
						<div className={styles.subtitle}>Три модели сотрудничества</div>
						<h2
							className={styles.title}
							dangerouslySetInnerHTML={{ __html: '<span>Выберите удобный формат</span> сотрудничества под ваши задачи' }}
						/>
					</AnimatedSection>

					<div className={styles.items}>
						{stages.map((item, index) => (
							<AnimatedSection key={index} animation='slideUp'>
								<div className={styles.item}>
									<div className={styles.itemHeader}>
										<div className={styles.itemNumber}>{item.number}</div>
										<h3 className={styles.itemTitle}>{item.title}</h3>
									</div>
									<p className={styles.itemDescription} dangerouslySetInnerHTML={{ __html: item.description }} />
								</div>
							</AnimatedSection>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

ThreeModels.displayName = 'ThreeModels'

export default ThreeModels
